import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import placeholderImg from "../assets/images/new/fav-removebg-preview.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
// import StupaImg from "../Images/stupa.jpg";
import "./ThankYou.css";
import { Link, Links } from "react-router-dom";
import DownloadApp from "../DownLoadApp/DownloadApp";

const ThankYou = () => {
  const location = useLocation();

  const navigate = useNavigate();

  console.log(location?.state?.paymentData, "dsds32222423");
  console.log(location?.state, "dsds32423");
  const HandleOrderPage = () => {
    if (location?.state?.moduleName === "PujaBooking") {
      navigate("/my-order-puja-booking");
    } else if (location?.state?.moduleName === "PrasadBooking") {
      navigate("/prasad-order");
    } else if (location?.state?.moduleName === "DailyPujaBooking") {
      navigate("/my-order-daily-Booking");
    } else if (location?.state?.moduleName === "MyStore") {
      navigate("/my-order");
    } else if (location?.state?.moduleName === "DarshanBooking") {
      navigate("/my-order-darshan-Booking");
    } else if (location?.state?.moduleName === "PujaAtTemple") {
      navigate("/my-order-puja-At-Temple");
    } else if (location?.state?.moduleName === "pujaKitSubscription") {
      navigate("/puja-kit-orders");
    }
  };
  return (
    <>

      <div className="thank-you--order-main">
        <div className="">
          <div>
            <img
              src={placeholderImg}
              alt="404"
              className="error-404__image"
              style={{ height: "12em" }}
            />
          </div>
          {location?.state?.moduleName === null || location?.state?.moduleName === undefined ? (
            <h3 className="error-404__text">Thank you for visiting Myomnamo! </h3>
          ) : (
            <h3 className="error-404__text">{location?.state?.moduleName === 'PanditRegister' || location?.state?.moduleName === 'ContactUs' ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Thank you for registering as a Pandit.<br /> Your profile has been created successfully. <br /> To manage your bookings and profile easily,
              download our app now.
            </span> : location?.state?.moduleName === 'pujaKitSubscription' ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Thank you for subscribing. <br /> We appreciate your interest and look forward to staying connected.</span> : <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Thank you for booking with Myomnamo! <br /> <span style={{ fontWeight: 'normal', fontSize: '18px' }}>Your booking has been placed successfully.<br /> We appreciate your trust in us and will keep you updated on your order status.</span></span>}  </h3>
          )}

          {location?.state?.isHomamPuja && (
            <span>
              Note: You will receive a separate email/WhatsApp message closer to the event date with the live streaming link to watch the Homam.
            </span>
          )}

          {location?.state?.moduleName !== null && location?.state?.moduleName !== undefined ? (
            <div className="error-404__btns ">

              <button
                style={{ padding: "5px 16px", fontSize: "14px" }}
                onClick={() => {
                  navigate("/");
                }}
                className="Normal-app-btn mx-3"
              >
                Home
              </button>
              {(location?.state?.moduleName !== 'PanditRegister' && location?.state?.moduleName !== 'ContactUs') && (
                <button
                  style={{ padding: "5px 16px", fontSize: "14px" }}
                  onClick={() => HandleOrderPage()}
                  className="Normal-app-btn"
                >
                  My Order
                </button>
              )}

            </div>
          ) : <button
            style={{ padding: "5px 16px", fontSize: "14px" }}
            onClick={() => {
              navigate("/");
            }}
            className="Normal-app-btn mx-3"
          >
            Home
          </button>}

        </div>

      </div>
      {location?.state?.moduleName === 'PanditRegister' && (

        <DownloadApp />
      )}
    </>
  );
};

export default ThankYou;
